var url = require('url')
const { jsonApiURL, oauth } = require('patreon')

/**
 * The Patreon OAuth settings used to be hardcoded here. They now come from
 * the build environment so they stay out of the repository.
 *
 * The redirect URL has to point at a server that can hold the OAuth exchange
 * and call back into the app. The old Parse server is gone, so Patreon
 * linking stays off until that server exists again.
 */
var CLIENT_ID = process.env.VUE_APP_PATREON_CLIENT_ID;
var redirectURL = process.env.VUE_APP_PATREON_REDIRECT_URL;

/**
 * The OAuth exchange needs the client secret. A secret cannot be part of a
 * browser build, because everyone who opens the site can read it. The
 * exchange has to run on a server, so the secret stays off the client until
 * that server exists again.
 */
var CLIENT_SECRET = '';

if (!CLIENT_ID || !redirectURL) {
  console.warn('Patreon linking is not configured, VUE_APP_PATREON_CLIENT_ID and VUE_APP_PATREON_REDIRECT_URL are needed.')
}

var patreonOAuth = oauth(CLIENT_ID, CLIENT_SECRET)

window.handleOAuthRedirectRequest = handleOAuthRedirectRequest
export async function getLoginUrl() {
    const retVal = await url.format({
        protocol: 'https',
        host: 'patreon.com',
        pathname: '/oauth2/authorize',
        query: {
            response_type: 'code',
            client_id: CLIENT_ID,
            redirect_uri: redirectURL,
            state: 'chill'
        }
    })
    return retVal
}


export function handleOAuthRedirectRequest(code) {
    return new Promise((resolve, reject) => {
        if (!CLIENT_SECRET) {
            reject(new Error('Patreon linking needs a server that can hold the OAuth exchange.'))
            return
        }
        patreonOAuth.getTokens(code, redirectURL).then(x => {
            (jsonApiURL(x.access_token))('/current_user')
        }).then(({ store }) => {
            resolve(store.findAll('user').map(user => user.serialize()))
        }).catch(x => reject(x))

    })
}
